import { List, Typography } from "antd";
import { useTranslation } from "react-i18next";
import type { StayCalendarDay, StayCalendarEvent, StayCalendarKind } from "~/utils";
import { StayStatusTag } from "./StayStatusTag";
import * as APITypes from "~/API";

const STAY_EVENT_KINDS = new Set<StayCalendarKind>([
  "stay",
  "pending",
  "confirmed",
  "checkedIn",
  "completed",
]);

const KIND_LEGEND_KEY = {
  lease: "Stay_cal_legend_lease",
  stay: "Stay_cal_legend_stay",
  pending: "Stay_cal_legend_pending",
  confirmed: "Stay_cal_legend_confirmed",
  checkedIn: "Stay_cal_legend_checkedIn",
  completed: "Stay_cal_legend_completed",
  block: "Stay_cal_legend_block",
} as const;

export function StayAgendaList({
  days,
  onEventClick,
}: {
  days: StayCalendarDay[];
  onEventClick: (event: StayCalendarEvent) => void;
}) {
  const { t } = useTranslation();
  const busyDays = days.filter((day) => day.inMonth && day.events.length > 0);

  if (busyDays.length === 0) {
    return (
      <Typography.Paragraph type="secondary">
        {t("Stay_cal_open")}
      </Typography.Paragraph>
    );
  }

  return (
    <List
      dataSource={busyDays}
      renderItem={(day) => (
        <List.Item>
          <List.Item.Meta
            title={
              <Typography.Text strong>
                {day.date}
                {day.isToday ? ` · ${t("Stay_today")}` : ""}
              </Typography.Text>
            }
            description={
              <div>
                {day.events.map((event) => (
                  <button
                    key={`${event.kind}-${event.id}`}
                    type="button"
                    onClick={() => onEventClick(event)}
                    style={{
                      display: "block",
                      width: "100%",
                      textAlign: "left",
                      marginBottom: 6,
                      padding: 0,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {STAY_EVENT_KINDS.has(event.kind) ? (
                      <StayStatusTag
                        status={
                          (event.status as APITypes.StayStatusType) ??
                          APITypes.StayStatusType.Confirmed
                        }
                      />
                    ) : null}
                    <Typography.Text>
                      {t(KIND_LEGEND_KEY[event.kind])} — {event.label}
                    </Typography.Text>
                  </button>
                ))}
              </div>
            }
          />
        </List.Item>
      )}
    />
  );
}
